import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { usePaginationConfig } from "@hooks/usePaginationConfig";
import {
  adminStoneEntregaSelector,
  getAdminStoneEntregaConsulta,
  resetAdminStoneEntregaConsulta,
} from "../../../features/adminStoneEntrega/adminStoneEntregaSlice";
import { useNotify } from "@hooks/useNotify";

// Tudo da busca: filtro escolhido, valor digitado, validação, paginação no servidor
// e o dispatch da consulta. O index só liga isto aos componentes.
export const useDeliverySearch = () => {
  const dispatch = useDispatch();
  const notify = useNotify();
  const { consultaData, consultaStatus, consultaError } = useSelector(
    adminStoneEntregaSelector
  );

  const [filtro, setFiltro] = useState("tracking_code");
  const [valor, setValor] = useState("");
  const [valorError, setValorError] = useState("");
  const [appliedQuery, setAppliedQuery] = useState(null);
  const [page, setPage] = useState(1);
  const paginationConfig = usePaginationConfig();
  const { pageSize } = paginationConfig;

  useEffect(() => {
    dispatch(resetAdminStoneEntregaConsulta());
  }, [dispatch]);

  useEffect(() => {
    if (consultaStatus === "rejected") {
      notify.error(
        consultaError?.erro ||
        consultaError?.message ||
        "Não foi possível consultar as deliveries. Tente novamente."
      );
    }
  }, [consultaStatus, consultaError]);

  const fetchPage = (query, nextPage, nextPageSize) => {
    dispatch(
      getAdminStoneEntregaConsulta({
        ...query,
        limit: nextPageSize,
        offset: (nextPage - 1) * nextPageSize,
      })
    );
  };

  const onChangeFiltro = (newFiltro) => {
    setFiltro(newFiltro);
    setValor("");
    setValorError("");
  };

  const onChangeValor = (newValor) => {
    setValor(newValor);
    setValorError("");
  };

  // Enter (ou bipagem, que termina em Enter) dispara a busca; no polo, a própria seleção
  const onSearch = (valorOverride = valor) => {
    const trimmed = typeof valorOverride === "string" ? valorOverride.trim() : valorOverride;
    if (trimmed === "" || trimmed === null || trimmed === undefined) {
      setValorError("Informe um valor para buscar.");
      return;
    }
    if (filtro === "delivery_id" && !/^\d+$/.test(trimmed)) {
      setValorError("O ID da delivery deve ser numérico.");
      return;
    }

    setValorError("");
    const query = { filtro, valor: trimmed };
    setAppliedQuery(query);
    setPage(1);
    fetchPage(query, 1, pageSize);
  };

  const onPageChange = (nextPage, nextPageSize) => {
    setPage(nextPage);
    fetchPage(appliedQuery, nextPage, nextPageSize);
  };

  return {
    filtro,
    valor,
    valorError,
    onChangeFiltro,
    onChangeValor,
    onSearch,
    deliveries: consultaData?.deliveries || [],
    loading: consultaStatus === "pending",
    pagination: {
      ...paginationConfig,
      current: page,
      total: consultaData?.total || 0,
      onChange: onPageChange,
    },
  };
};
